import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const SpotprisOmrade = lazy(() => import("@/pages/spotpris/SpotprisOmrade"));

export const Route = createFileRoute("/spotpris/elomrade-se2")({
  head: () => seoHead("/spotpris/elomrade-se2"),
  component: () => <SpotprisOmrade />,
});
